"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var TreeSelector_1 = require("../APMetaDataForm/TreeSelector");
var styles_1 = require("../APMetaDataForm/styles");
var APMetaDataBaseSection = /** @class */ (function (_super) {
    __extends(APMetaDataBaseSection, _super);
    function APMetaDataBaseSection() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    APMetaDataBaseSection.prototype.render = function () {
        var _a = this.props, exportedMetadata = _a.exportedMetadata, onEdit = _a.onEdit;
        var get = function (obj, path, defaultValue) {
            if (defaultValue === void 0) { defaultValue = null; }
            return String.prototype.split
                .call(path, /[,[\].]+?/)
                .filter(Boolean)
                .reduce(function (a, c) { return (Object.hasOwnProperty.call(a, c) ? a[c] : defaultValue); }, obj);
        };
        return (react_1.default.createElement(styles_1.StyledSection, { animationIndex: 1, title: "Metadata summary" },
            onEdit && react_1.default.createElement(styles_1.EditNavLink, { onClick: onEdit }, "Edit metadata"),
            react_1.default.createElement(styles_1.MetadataSummary, null,
                react_1.default.createElement(styles_1.MetadataSummaryLine, null,
                    react_1.default.createElement(styles_1.SummaryLabel, null, "Industry:"),
                    react_1.default.createElement(styles_1.SummaryValue, null, get(exportedMetadata, 'industry.data.value'))),
                react_1.default.createElement(styles_1.MetadataSummaryLine, null,
                    react_1.default.createElement(styles_1.SummaryLabel, null, "Revenue:"),
                    react_1.default.createElement(styles_1.SummaryValue, null, get(exportedMetadata, 'revenue.data.value'))),
                react_1.default.createElement(styles_1.MetadataSummaryLine, null,
                    react_1.default.createElement(styles_1.SummaryLabel, null, "Number of employees:"),
                    react_1.default.createElement(styles_1.SummaryValue, null, get(exportedMetadata, 'employeesNumber.data.value'))),
                react_1.default.createElement(styles_1.MetadataSummaryLine, null,
                    react_1.default.createElement(styles_1.SummaryLabel, null, "Head office location:"),
                    react_1.default.createElement(styles_1.SummaryValue, null, get(exportedMetadata, 'headOfficeLocation.data.value'))),
                react_1.default.createElement(styles_1.MetadataSummaryLine, null,
                    react_1.default.createElement(styles_1.SummaryLabel, null, "Countries operated in:"),
                    react_1.default.createElement(styles_1.SummaryValue, null, get(exportedMetadata, 'geographies.data')
                        .map(function (item) { return TreeSelector_1.getCodeFromItem(item).name; })
                        .join(', '))))));
    };
    return APMetaDataBaseSection;
}(react_1.Component));
exports.APMetaDataBaseSection = APMetaDataBaseSection;
//# sourceMappingURL=APMetaDataBaseSection.js.map